// extracted by mini-css-extract-plugin
export default {"bodyHome":"Home_bodyHome__LqzkJ","spaceCharts":"Home_spaceCharts__29LUR"};